import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Card from '../../layout/Card';
import ModuleHome from '../../layout/ModuleHome';
import { breadcrumbsPropTypes } from '../../common/resource/proptypes/CommonPropTypes';

export const UserHome = ({ cards, breadcrumbs }) => (
  <ModuleHome
    title="Gestión de Usuarios"
    text="Éste es el módulo de Gestión de Usuarios."
    cards={cards}
    breadcrumbs={breadcrumbs}
  />
);

const mapStateToProps = ({ UserUnit }) => ({
  cards: UserUnit.UnitHome.get('cards'),
  breadcrumbs: UserUnit.UnitHome.get('breadcrumbs'),
});

UserHome.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  cards: PropTypes.arrayOf(PropTypes.shape(Card.propTypes)).isRequired,
};

export default connect(mapStateToProps)(UserHome);
